export const catTipoItem = Object.freeze({
    PAQUETE: "PAQUETE",
    EXTRA: "EXTRA",
    PLAZA: "PLAZA",
    PLAZAM: "PLAZAM",
    PLAZAI: "PLAZAI",
    SALIDA: "SALIDA",
    DESCUENTO_PORCENTAJE: "DESCUENTO_POCENTAJE",
    DESCUENTO_MONTO: "DESCUENTO_MONTO",
    PROMOCION: "PROMOCION",
})